module.exports = __webpack_public_path__ + "img/screenshot.3ba0c663.png";